export default __webpack_public_path__ + "static/kotlin-logo-e561bb24367c5fce5fcdaedb726b621b.png";